import React from 'react';
import { render } from 'react-dom';
import App from './containers/App/App';

render(<App />, document.getElementById('root'));
